<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ack">Acknowledgments</p>
<p class="ack1">Thank you, Mom and Dad, for supporting me each time I took the road less traveled, even though you lost sleep.</p>
<p class="ack1">Thank you, Just in, for being the wind beneath my wings.</p>
<p class="ack1">Thank you, Leslie, for being there at the start and cheering me on.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_ack.vue?2732e728